import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-referrer-dialog',
	templateUrl: './referrer-dialog.component.html',
	styleUrls: ['./referrer-dialog.component.scss'],
})
export class ReferrerDialogComponent implements OnInit {
	form: FormGroup;
	hasReferrer = false;
	constructor(
		private dialogRef: MatDialogRef<ReferrerDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private fb: FormBuilder,
	) {}

	ngOnInit(): void {
		this.initForm();
	}

	private initForm() {
		this.form = this.fb.group({
			referrer_name: [''],
			referrer_phone: ['', Validators.pattern('^[+]?[0-9]{1,5}-?[0-9]{7,8}$')],
		});
	}

	onSubmit() {
		if (this.form.valid) {
			this.dialogRef.close(this.form.value);
		}
	}
	close() {
		this.dialogRef.close('close');
	}
}
